import {useNavigate, useSearchParams} from "react-router-dom";
import {apiGetStatistical, apiUpdateStatistical} from "../../api";
import {useLoading} from "../../context/LoadingContext";
import React, {useEffect, useState} from "react";
import {Button, DatePicker, Form, Input, InputNumber} from "antd";
import {REVENUES, STATISTICAL} from "../../assets/constants/route_path";
import {LeftCircleOutlined} from "@ant-design/icons";
import {formatCurrency} from "../../utils/string-utils";
import moment from "moment/moment";
import {toastError, toastSuccess} from "../../utils/toast";

const {TextArea} = Input;

const rules = {
    OTPConfirm: [
        { required: true, message: 'Vui lòng nhập mã code đăng nhập' },
        { min: 6, message: 'Mã code đăng nhập phải có 6 ký tự' },
    ],
};

export default function EditStatistical() {
    const [searchParams] = useSearchParams()
    const statisticalId = searchParams.get('id')
    const { setIsLoading } = useLoading();
    const [currentStatistical, setCurrentStatistical] = useState<any>(null);
    const navigate = useNavigate()
    const [form] = Form.useForm();

    const getStatistical =  async (id: string | null) => {
        try {
            setIsLoading(true)
            const resData = await apiGetStatistical({
                id: id
            });
            if(resData.data.partnerStatistical !== null) {
                resData.data.partnerStatistical.date = moment([
                    resData.data.partnerStatistical?.year
                    , resData.data.partnerStatistical?.month
                    , resData.data.partnerStatistical?.day
                ]);
                setCurrentStatistical(resData.data.partnerStatistical);
                form.setFieldsValue(resData.data.partnerStatistical)
            }
        } catch (error) {
            console.error('Failed to fetch statistical data:', error);
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        getStatistical(statisticalId);
    }, [])

    const handleUpdateStatistical = async (values: any) => {
        try {
            setIsLoading(true);
            const req = {
                ID: statisticalId,
                CpCode: values.cpCode,
                Day: currentStatistical.day,
                Month: currentStatistical.month,
                Week: currentStatistical.week,
                Year: currentStatistical.year,
                BalanceStartDate: values.balanceStartDate,
                BalanceEndDate: values.balanceEndDate,
                Revenue: values.revenue,
                RevenueNet: values.revenueNet,
                Refund: values.refund,
                Deposit: values.deposit,
                Description: values.description,
                OTPConfirm: values.OTPConfirm,
            };
            const resp = await apiUpdateStatistical(req);
            if (resp.status === 200) {
                toastSuccess('Cập nhật dữ liệu thành công!')
                form.resetFields(['OTPConfirm']);
            }
        } catch (error) {
            toastError('Vui lòng kiểm tra lại thông tin!')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <div style={{display: 'flex', alignItems: 'center', gap: 200, marginBottom: 20}}>
                <Button
                    onClick={() => navigate(REVENUES + STATISTICAL + `?cpCode=${currentStatistical?.cpCode}`)}
                    icon={<LeftCircleOutlined/>}
                    style={{background: 'gray', color: 'white'}}
                >
                    Trở lại
                </Button>
                <h2>Đối tác: {currentStatistical?.cpCode}</h2>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Form
                    style={{ width: '700px' }}
                    form={form}
                    onFinish={handleUpdateStatistical}
                    labelAlign="left"
                    labelCol={{span: 6}}
                >
                    <Form.Item
                        label="Thời gian"
                        name="date"
                        rules={[{required: true, message: 'Vui lòng nhập thời gian'}]}
                    >
                        <DatePicker
                            disabled
                            style={{width: '100%'}}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Dư đầu ngày"
                        name="balanceStartDate"
                        rules={[{required: true, message: 'Vui lòng nhập dư đầu ngày'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                            formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Dư cuối ngày"
                        name="balanceEndDate"
                        rules={[{required: true, message: 'Vui lòng nhập dư cuối ngày'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                            formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Bán trong ngày"
                        name="revenue"
                        rules={[{required: true, message: 'Vui lòng nhập bán trong ngày'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                            formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Bán trong ngày sau CK"
                        name="revenueNet"
                        rules={[{required: true, message: 'Vui lòng nhập bán trong ngày sau CK'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                            formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Hoàn tiền trong ngày"
                        name="refund"
                        rules={[{required: true, message: 'Please input refund!'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                            formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Nạp trong ngày"
                        name="deposit"
                        rules={[{required: true, message: 'Please input deposit!'}]}
                    >
                        <InputNumber
                            style={{width: '100%'}}
                            formatter={value => formatCurrency(Number(value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Mô tả"
                        name="description"
                    >
                        <TextArea style={{width: '100%'}} rows={3}/>
                    </Form.Item>
                    <Form.Item label="Mã OTP xác nhận" name="OTPConfirm" rules={rules.OTPConfirm}>
                        <Input.Password name="OTPConfirm" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Cập nhật
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </>
    );
}